export default __webpack_public_path__ + "static/media/NarfClinic.910449b8.mp4";